const getters = {
  token: state => state.user.token,
  tree: state => state.user.tree,
  user:state => state.user.user,
  addRouters: state => state.permission.addRouters,
  permission_routers: state => state.permission.routers,
  keepAliveList: state => state.aliveRouter.keepAliveList,
  visitedList: state => state.aliveRouter.visitedList,
  error: state => state.user.error,
  username: state => state.user.userTel,
  loginVisible:state => state.app.loginVisible
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js